import * as React from "react";
import Dropzone from "react-dropzone-uploader";
import styled from "react-emotion";
import {Icon} from "bloomer";
import Card from "../../../elements/Card";
import {BACKEND_URI} from "../../../utils/Constants";
import {getTranscription} from "../../../api/models/SpeechRecognition";
import SendGAEvent, {GAEventActions, GAEventModels} from "../../../utils/SendGAEvent";
import Button from "../../../elements/Button";
import {getAuthorizationHeaders} from "../../../utils/auth";
import ErrorUtils from "../../../utils/ErrorUtils";
import {toast} from "react-toastify";

const Layout = ({
  input,
  previews,
  submitButton,
  dropzoneProps,
  files,
  extra: { maxFiles }
}) => {
  return (
    <div>
      {previews}

      <div {...dropzoneProps}>{files.length < maxFiles && input}</div>

      {files.length > 0 && submitButton}
    </div>
  );
};

const Container = styled("div")`
  margin-left: 10px;
  min-height: 200px;
`;

const DropArea = styled("div")`
  min-height: 200px;
  border: 1px dashed black;
  text-align: center;
  line-height: 200px;
  color: grey;
`;

const InformationCard = styled("div")`
  border: 1px solid lightgrey;
  border-radius: 5px;
  padding: 5px;
  min-height: 50px;
  margin: 5px;
`;

const ButtonDiv = styled("div")`
  margin-left: 5px;
`;

class SpeechRecognitionModel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploaded: false,
      loading: false,
      status: "",
      JobName: "",
      showFormatWarning: false
    };
  }

  componentDidMount() {
    SendGAEvent(GAEventActions.VIEW_MODEL, GAEventModels.SPEECH_RECOGNITION);
  }

  // specify upload params and url for your files
  getUploadParams = ({ meta, file }) => {
    const url = `${BACKEND_URI}` + "/start-transcription-job";
    const body = new FormData();
    const JobName = Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, "")
      .substr(0, 5);

    body.append("AudioData", file);
    body.append("TranscriptionJobName", JobName);
    body.append("LanguageCode", "en-US");
    body.append("MediaFormat", "wav");

    this.setState({ JobName });

    return {
      url,
      meta: { fileUrl: `${url}/${encodeURIComponent(meta.name)}` },
      body,
      ...getAuthorizationHeaders()
    };
  };

  // called every time a file's `status` changes
  handleChangeStatus = ({ meta, file, xhr }, status) => {
    this.setState({ status });
    if (status === "preparing") {
      this.setState({ loading: true });
      this.timeoutRef = setTimeout(() => {
        this.setState({ uploaded: true, loading: false });

        SendGAEvent(GAEventActions.CALL_MODEL, GAEventModels.SPEECH_RECOGNITION);
      }, 4000);
    } else if (status === "error_validation") {
      clearTimeout(this.timeoutRef);
      this.setState({ loading: false, showFormatWarning: true });
    } else if (status === "error_upload") {
      clearTimeout(this.timeoutRef);
      this.setState({
        loading: false
      });
      if (xhr.status === 429) {
        toast.error(ErrorUtils.messageContent.REQUEST_LIMIT_EXCEEDED);
      }
    }
  };

  // receives array of files that are done uploading when submit button is clicked
  handleSubmit = (files, allFiles) => {
    allFiles.forEach(f => f.remove());
  };

  componentDidUpdate = () => {
    if (this.state.status === "done") {
      if (!this.state.response) {
        setTimeout(() => {
          getTranscription(this.state.JobName).then(response => {
            this.setState({ response: response.data });
          });
        }, 35000);
      } else {
        if (!this.state.response.success) {
          setTimeout(() => {
            getTranscription(this.state.JobName).then(response => {
              this.setState({ response: response.data });
            });
          }, 35000);
        }
      }
    }
  };

  validateFile = ({meta, file}) => {
    if (meta.type.startsWith('audio/') && meta.name.toLowerCase().endsWith('.wav')) {
      return false;
    }
    return true;
  };

    resetState = async (e) => {
      e.target.blur();

        this.setState({
            uploaded: false,
            loading: false,
            status: "",
            JobName: "",
            showFormatWarning: false,
            response: null
        });
    };

  render() {
    return (
      <React.Fragment>
        <Container>
          <Card>
            {this.state.loading && (
              <div>
                  <span>Uploading...</span>
                  <Icon className="fas fa-spinner fa-spin" />
              </div>
            )}
            {this.state.uploaded && !this.state.loading && (
              <div> Speech Recognition & Transcription Output </div>
            )}
            {!this.state.uploaded && !this.state.loading && (
              <Dropzone
                validate={this.validateFile}
                getUploadParams={this.getUploadParams}
                onChangeStatus={this.handleChangeStatus}
                LayoutComponent={Layout}
                onSubmit={this.handleSubmit}
                multiple={false}
                inputContent={(files, extra) =>
                {
                  if (this.state.showFormatWarning) {
                    return <DropArea style={{color: 'red'}}>The model only accepts wav format files. Please upload wav file.</DropArea>;
                  }
                  return <DropArea>Drop Your Audio Files Here</DropArea>;
                }
                }
              />
            )}
            {
                this.state.uploaded && !this.state.loading && <InformationCard>
                    {
                        this.state.response &&
                        this.state.response.success &&
                        this.state.response.transcript && <div>{this.state.response.transcript}</div>
                    }
                    {
                        this.state.response &&
                        this.state.response.success &&
                        !this.state.response.transcript && <div>Unable to transcribe.</div>
                    }
                    {
                        this.state.response && !this.state.response.success && <div>Unable to transcribe.</div>
                    }
                    {
                        !this.state.response && <div>
                            <span>Transcribing...</span>
                            <Icon className="fas fa-spinner fa-spin" />
                            <span>(waiting time: 40 sec)</span>
                        </div>
                    }
              </InformationCard>
            }
              {
                  this.state.uploaded &&
                  !this.state.loading &&
                  this.state.response && <ButtonDiv>
                      <Button onClick={this.resetState}>Reset</Button>
                  </ButtonDiv>
              }
          </Card>
        </Container>
      </React.Fragment>
    );
  }
}

export default SpeechRecognitionModel;



// WEBPACK FOOTER //
// ./src/routes/Dashboard/SpeechRecognition/SpeechRecognitionModel.jsx